import React from 'react';

import { connect } from 'react-redux';
import { compose } from 'redux';
import { FormSection, Field, reduxForm, submit, isSubmitting, formValueSelector } from 'redux-form';
import { TextField, SelectField } from 'redux-form-material-ui';
import FlatButton from 'material-ui/FlatButton';
import MenuItem from 'material-ui/MenuItem';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import PermissionFields from 'components/landlord_app/users/PermissionForm/PermissionFields';

import Header from 'components/shared/Header';

import * as validator from 'helpers/Validator';
import { deepDiver } from 'helpers/utilities';
import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';
import PreferenceField from 'components/shared/PreferenceField';
import { titleize } from 'helpers/Formatter';

import { getTranslatedString } from 'helpers/i18n';

const style = {
  textField: {
    fontSize: '14px',
    textAlign: 'left',
    margin: 'auto',
    marginTop: '-25px',
  },
};

let RoleForm = props => {
  return (
    <form onSubmit={props.handleSubmit.bind(this)}>
      <Header name={getTranslatedString('landLordPortal.roleDialog.header.details')} />

      <div className="row" style={{ margin: '10px 40px 10px 30px' }}>
        <div className="col-sm-12">
          <Field
            name="name"
            component={TextField}
            floatingLabelText={getTranslatedString('landLordPortal.roleDialog.labelText.roleName')}
            multiLine={false}
            fullWidth
            validate={[validator.required]}
            style={{ marginTop: '-15px', fontSize: '14px' }}
          />
        </div>
      </div>

      {props.landlordSSOEnabled && (
        <div className="row" style={{ margin: '10px 40px 10px 30px' }}>
          <div className="col-sm-12">
            <PreferenceField
              toggleValue={props.sso_enabled}
              toggleName="sso_enabled"
              toggleLabelName={getTranslatedString('landLordPortal.roleDialog.labelName.SSO')}
              preferenceDescription={getTranslatedString(
                'landLordPortal.roleDialog.SSODescription'
              )}
            >
              <Field
                name="role_sso_provider"
                component={SelectField}
                floatingLabelText={getTranslatedString(
                  'landLordPortal.roleDialog.labelText.SSOSelectProvider'
                )}
                style={{
                  fontSize: '14px',
                  maxWidth: '250px',
                  textAlign: 'left',
                  margin: 'auto',
                  marginTop: '-25px',
                }}
                fullWidth
                disabled={!props.sso_enabled}
                validate={[validator.required]}
              >
                {props.sso_providers.map(provider => {
                  return <MenuItem value={provider} primaryText={`${titleize(provider)}`} />;
                })}
              </Field>
            </PreferenceField>
          </div>
        </div>
      )}

      <div className="row" style={{ margin: '10px 40px 10px 30px' }}>
        <div className="col-sm-12">
          <PreferenceField
            toggleValue={props.whitelisted_ips_enabled}
            toggleName="whitelisted_ips_enabled"
            toggleLabelName={getTranslatedString('landLordPortal.roleDialog.labelName.ipWhiteList')}
            preferenceDescription={getTranslatedString(
              'landLordPortal.roleDialog.ipWhiteListDescription'
            )}
          >
            <Field
              name="whitelisted_ips"
              component={TextField}
              placeholder={getTranslatedString('landLordPortal.roleDialog.ipWhiteList.placeholder')}
              validate={[validator.required, validator.validIps]}
              fullWidth
              disabled={!props.whitelisted_ips_enabled}
              style={style.textField}
            />
          </PreferenceField>
        </div>
      </div>

      <FormSection name="permissions">
        <PermissionFields showMessaging={props.showMessaging} />
      </FormSection>
    </form>
  );
};

const ROLE_FORM = 'role_form';
const selector = formValueSelector(ROLE_FORM);
const mapStates = (state, _) => ({
  whitelisted_ips_enabled: selector(state, 'whitelisted_ips_enabled'),
  sso_enabled: selector(state, 'sso_enabled'),
  landlordSSOEnabled: state.userTypes.landlordSSOEnabled,
});

const ConnectComponent = connect(mapStates);

const ReduxRoleForm = reduxForm({
  form: ROLE_FORM,
});

RoleForm = compose(ConnectComponent, ReduxRoleForm)(RoleForm);

let RoleDialog = props => {
  const onSubmit = formData => {
    props.createOrUpdateCompanyRole(deepDiver(props, 'roleDetails.id'), formData).then(() => {
      props.toggleDialog();
    });
  };

  return (
    <div>
      <Dialog
        disableBackdropClick
        fullScreen={props.fullScreen}
        open={props.dialogOpen}
        onClose={props.toggleDialog}
        aria-labelledby="view-maintenance-ticket"
        classes={{
          paper: 'form-dialog',
        }}
      >
        <DialogTitle id="create-maintenance-ticket">
          <h3 style={{ textAlign: 'center', margin: 0 }}>
            {getTranslatedString('landLordPortal.roleDialog.header.companyRole')}
          </h3>
        </DialogTitle>
        <DialogContent>
          <RoleForm
            onSubmit={onSubmit}
            initialValues={props.roleDetails}
            showMessaging={props.showMessaging}
            sso_providers={props.sso_providers}
          />
        </DialogContent>

        <DialogActions style={{ display: 'block' }}>
          <FlatButton
            onClick={props.toggleDialog}
            id="close-button"
            style={{ color: AccentColor() }}
          >
            {getTranslatedString('landLordPortal.roleDialog.cancel')}
          </FlatButton>
          <FlatButton
            onClick={() => props.submit('role_form')}
            variant="raised"
            disabled={props.submitting}
            id="submit-button"
            style={{
              color: 'white',
              backgroundColor: props.submitting ? colors.LIGHT_GRAY : AccentColor(),
            }}
          >
            {getTranslatedString('landLordPortal.roleDialog.save')}
          </FlatButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

RoleDialog = connect(
  store => ({
    submitting: isSubmitting('role_form')(store),
    showMessaging: store.userTypes.showMessaging,
    sso_providers: store.userTypes.ssoProvidersAgent,
  }),
  { submit }
)(RoleDialog);

export default withMobileDialog()(RoleDialog);
